import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=3246fbc6&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=ts&"
export * from "./editor.vue?vue&type=script&lang=ts&"
import style0 from "./editor.vue?vue&type=style&index=0&id=3246fbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246fbc6",
  null
  
)

export default component.exports